import { useTranslation } from 'react-i18next';
import { Card, CardContent, Text } from '@shared/ui';

const SPACING_STEPS = [4, 8, 12, 16, 20, 24, 32, 40, 48];

export function SpacingScale() {
  const { t } = useTranslation();

  return (
    <Card>
      <CardContent className="flex flex-wrap gap-4 p-6">
        {SPACING_STEPS.map((value) => (
          <div key={value} className="flex flex-col items-center gap-2">
            <div
              className="rounded-sm bg-primary/20"
              style={{ width: value, height: value }}
              aria-hidden="true"
            />
            <Text size="xs" color="muted">
              {value}
              {t('uiLibrary.tokens.spacing.px')}
            </Text>
          </div>
        ))}
      </CardContent>
    </Card>
  );
}
